export default __webpack_public_path__ + "static/media/nu.12c3d7ea.png";